import "./Estatutos.css";

function Estatutos() {
  console.log("Renderizando Estatutos");
  return (
    <div className="estatutos-container">

      {/* HERO */}
      <div className="estatutos-hero">
        <div className="estatutos-text">
          <h1>Estatutos</h1>
          <p>
            En esta sección encontrarás información relevante sobre nuestras normas
            y los procesos de negociación colectiva que fortalecen nuestros derechos.
          </p>
        </div>

        <div className="estatutos-img">
          <img
            src="https://images.unsplash.com/photo-1609220136736-443140cffec6?q=80&w=1200"
            alt="familia trabajador"
          />
        </div>
      </div>

      {/* CARDS */}
      <div className="estatutos-grid">

        <div className="card-est">
  <div className="icon blue">📘</div>
  <h3>Estatutos</h3>
  <p>
    Consulta el documento completo que establece normas, derechos y deberes.
  </p>
  <button 
  className="btn blue"
  onClick={() => {
    console.log('Intentando abrir PDF...');
    const pdfUrl = '/Estatutos/Estatuto.pdf';
    console.log('Ruta:', pdfUrl);
    window.open(pdfUrl, '_blank');
  }}
>
  Ver Estatutos
</button>
</div>

        {/* CARD 2 */}
        <div className="card-est">
          <div className="icon green">🤝</div>
          <h3>Negociación 2026 - Davita SAS</h3>
          <p>
            Información del inicio del proceso de negociación colectiva 2026.
          </p>
          <button className="btn green">Ver Información</button>
        </div>

        {/* CARD 3 */}
        <div className="card-est">
          <div className="icon purple">🤝</div>
          <h3>Negociación - RTS SAS</h3>
          <p>
            Consulta el inicio del proceso de negociación colectiva con RTS.
          </p>
          <button className="btn purple">Ver Información</button>
        </div>

      </div>

      {/* INFO EXTRA */}
      <div className="info-banner">
        Mantente informado sobre cada avance importante del sindicato.
      </div>

    </div>
  );
}

export default Estatutos;